<template>
<div class="on-job-list-page">
  <div class="page-body container">
    <div class="tab-box">
      <div class="tab-item" :class="{active: tab === 0}">在职证明</div>
    </div>
    <div class="nodata-box" v-if="tableInfo.list.length === 0 && !tableInfo.searchText">
      <img class="nodata-img" src="../../assets/imgs/on-job/on-job-nodata.png" alt="">
      <div class="nodata-text">上传护照资料，在线填写信息<br />自动翻译生成英文在职证明</div>
      <div class="add-btn s-btn btn-blue" @click="addOnJob">+ 新增在职证明</div>
    </div>
    <div class="list-box" v-else>
      <div class="list-header">
        <div class="search-box">
          <el-input class="s-input" :placeholder="'搜索客户名称'" v-model="tableInfo.searchText" @input="startSearch" />
        </div>
        <div class="add-box">
          <div class="add-btn s-btn btn-blue" @click="addOnJob">+ 新增在职证明</div>
        </div>
      </div>
      <div class="list-body">
        <table class="s-table" rules="groups" frame="box">
          <thead>
            <tr>
              <th>
                <el-checkbox :value="checkedAll" @input="handleSelectAll"></el-checkbox>
              </th>
              <th>ID</th>
              <th class="text-center">护照图</th>
              <th class="text-center" width="200">客户名称</th>
              <th class="text-center">最后更新时间</th>
              <th class="text-center" width="250">创建账号</th>
              <th class="text-center">详情</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="v in tableInfo.list" :key="v.archives_onjob_id">
              <td>
                <el-checkbox :value="checkedIdList.indexOf(v.archives_onjob_id) > -1" @input="handleSelectItem(v)"></el-checkbox>
              </td>
              <td>{{v.archives_onjob_id}}</td>
              <td class="text-center">
                <div class="passport-img-box">
                  <img @click="previewImg(v.img_url)" :src="v.img_url" class="passport-img" alt="">
                </div>
              </td>
              <td class="text-center">
                <div class="customer-name" @click="showPrintDialog(v)">{{v.name || '未命名'}}</div>
              </td>
              <td class="text-center">{{v.update_time}}</td>
              <td class="text-center">{{`${v.phone_number}(${v.peer_name})`}}</td>
              <td class="text-center" >
                <div class="text-btn" @click="showPrintDialog(v)">下载</div>
                <div class="text-btn" @click="editOnJob([v.archives_onjob_id])">编辑</div>
                <div class="text-btn" @click="gotoCountryPage(v)">办理签证</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="list-footer" v-if="tableInfo.list.length">
        <div class="handler-box">
          <el-button class="s-btn btn-blue is-plain" :loading="batchDownloadLoading" @click="handleBatchBtn('download')">批量下载</el-button>
          <el-button class="s-btn btn-blue is-plain" @click="handleBatchBtn('email')">批量发送邮箱</el-button>
        </div>
        <el-pagination
          class="pagination"
          @current-change="getList"
          :current-page.sync="tableInfo.page"
          :page-size="10"
          layout="total, prev, pager, next"
          :total="tableInfo.totalCount" >
          </el-pagination>
      </div>
      <div class="search-nodata" v-else>
        <img class="nodata-img" src="../../assets/imgs/on-job/search-nodata.png" alt="">
        <div class="nodata-text">未查询到记录</div>
      </div>
    </div>

  </div>
  <created-on-job-dialog
    :show.sync="showCreatedOnJobDialog"
  >
  </created-on-job-dialog>

  <on-job-print-dialog
    :show.sync="printDialog.visible"
    :on-job-id="printDialog.id"
    @send-mail="handleSingleSendMail"
  >
  </on-job-print-dialog>

  <on-job-send-mail-dialog
    :show.sync="sendMailDialog.visible"
    :on-job-id-list="sendMailDialog.idList"
    :show-header="sendMailDialog.showHeader"
  ></on-job-send-mail-dialog>

  <!-- 多图预览弹窗 -->
  <multi-image-preview v-model="multiImagePreviewOpen" :multiImageArray="multiImageArray"></multi-image-preview>
</div>
</template>

<script>
import _ from 'lodash';
import sensorsdata from 'sa-sdk-javascript';
import User from '../../libs/user.js';
import Http from '../../libs/http';
import CreatedOnJobDialog from './components/created-on-job-dialog';
import multiImagePreview from '../../components/common/multi-image-preview';
import OnJobPrintDialog from './components/on-job-print-dialog';
import utils from '../../libs/utils';
import OnJobSendMailDialog from './components/on-job-send-mail-dialog';

export default {
  components: {
    CreatedOnJobDialog,
    multiImagePreview,
    OnJobPrintDialog,
    OnJobSendMailDialog,
  },
  data() {
    return {
      tab: 0,
      tableInfo: {
        list: [],
        page: 1,
        totalCount: 0,
        searchText: '',
        loading: false,
      },
      showCreatedOnJobDialog: false, // 显示创建在职证明弹窗
      checkedList: [],
      multiImageArray: [],
      multiImagePreviewOpen: false,
      printDialog: {
        visible: false,
        id: 0,
      },
      sendMailDialog: {
        visible: false,
        idList: [],
      },
      batchDownloadLoading: false, // 批量下载loading
    };
  },
  watch: {
  },
  computed: {
    checkedAll() {
      if (!this.tableInfo.list.length) return false;
      return this.tableInfo.list.every(item =>
        this.checkedList.findIndex(checkedItem => item.archives_onjob_id === checkedItem.archives_onjob_id) > -1,
      );
    },
    checkedIdList() {
      return this.checkedList.map(item => item.archives_onjob_id);
    },
  },
  created() {
    this.tableInfo.page = +this.$route.query.page || 1;
    this.tableInfo.searchText = this.$route.query.search_text || '';
    this.getList();
  },
  methods: {
    startSearch: _.debounce(function () {
      this.page = 1;
      this.checkedList = [];
      this.getList();
    }, 200),
    // 记录列表查询参数
    recordParams() {
      this.$router.replace({ query: { page: this.tableInfo.page, search_text: this.tableInfo.searchText } });
    },
    getList() {
      this.recordParams();
      this.tableInfo.loading = true;
      Http.post('/archives_onjob_brief_query', {
        page: this.tableInfo.page,
        name: this.tableInfo.searchText || undefined,
      }).then((res) => {
        this.tableInfo.list = res.page_data;
        this.tableInfo.totalCount = res.total_count;
        this.tableInfo.loading = false;
      }).catch((e) => {
        if (e) console.log(e);
        this.tableInfo.loading = false;
      });
    },
    addOnJob() {
      sensorsdata.track('new_proof', {
        peer_name: User.peer.peer_name,
        visa_peer_id: User.peer.visa_peer_id,
      });
      this.showCreatedOnJobDialog = true;
    },
    editOnJob(idList) {
      this.$router.push({
        name: 'EditOnJob',
        query: {
          id_list: encodeURIComponent(JSON.stringify(idList)),
        },
      });
    },
    // 选中单项
    handleSelectItem(item) {
      const index = this.checkedList.findIndex(checkedItem => item.archives_onjob_id === checkedItem.archives_onjob_id);
      if (index > -1) {
        this.checkedList.splice(index, 1);
      } else {
        this.checkedList.push(item);
      }
    },
    // 点击全选
    handleSelectAll() {
      if (this.checkedAll) {
        this.tableInfo.list.forEach((item) => {
          const index = this.checkedList.findIndex(checkedItem => checkedItem.archives_onjob_id === item.archives_onjob_id);
          if (index > -1) {
            // 取消全选
            this.checkedList.splice(index, 1);
          }
        });
      } else {
        this.tableInfo.list.forEach((item) => {
          const index = this.checkedList.findIndex(checkedItem => checkedItem.archives_onjob_id === item.archives_onjob_id);
          if (index === -1) {
            // 全选
            this.checkedList.push(item);
          }
        });
      }
    },
    // 预览图片
    previewImg(url) {
      this.multiImageArray = [url];
      this.multiImagePreviewOpen = true;
    },
    // 跳转至国家页
    gotoCountryPage(item) {
      sensorsdata.track('On_the_job_visa', {
        peer_name: User.peer.peer_name,
        visa_peer_id: User.peer.visa_peer_id,
        country: item.country || '',
      });
      if (item.country_id && item.country_status === 0) {
        this.$router.push({ name: 'country', params: { id: item.country_id } });
      } else {
        this.$router.push({ name: 'index' });
      }
    },
    // 显示打印弹窗
    showPrintDialog(item) {
      if (item.status === 1) {
        this.printDialog.visible = true;
        this.printDialog.id = item.archives_onjob_id;
      } else {
        this.showInfoUnfinishedTips([item.archives_onjob_id], false);
      }
    },
    // 显示信息未完成的提示
    showInfoUnfinishedTips(idList, isBatch) {
      utils.msgbox.confirm(`${isBatch ? '所选部分客户' : '该客户'}信息不完整，由于在职证明文档填入内容大部分需为机打，请完善信息后下载。`, '信息未完善', {
        confirmButtonText: '完善信息',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.editOnJob(idList);
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 点击批量
    handleBatchBtn(type) {
      // 未完成的list
      const unfinishedCheckedList = this.checkedList.filter(item => item.status === 0);
      if (this.checkedList.length === 0) {
        return this.$message.error('请先勾选需批量处理的客户对象');
      } else if (unfinishedCheckedList.length > 0) {
        // 存在未填写完成的
        this.showInfoUnfinishedTips(unfinishedCheckedList.map(item => item.archives_onjob_id), true);
        return;
      }
      if (type === 'email') {
        this.showBatchSendMailDialog(this.checkedIdList);
      } else {
        this.batchDownloadOnJob(this.checkedIdList);
      }
    },

    // 显示发送到邮箱
    showBatchSendMailDialog(idList) {
      this.sendMailDialog.idList = idList;
      this.sendMailDialog.visible = true;
      this.sendMailDialog.showHeader = undefined;
    },

    // 处理打印弹窗触发的发送到邮箱
    handleSingleSendMail(id, showHeader) {
      this.sendMailDialog.showHeader = showHeader;
      this.sendMailDialog.visible = true;
      this.sendMailDialog.idList = [id];
    },

    // 批量下载在职证明
    batchDownloadOnJob(idList) {
      if (this.batchDownloadLoading) return;
      this.batchDownloadLoading = true;
      Http.post('/archives_onjob_download', {
        onjob_id_list: idList,
      }).then((res) => {
        window.open(res.url);
        this.batchDownloadLoading = false;
        sensorsdata.track('On_the_job_bulk_download', {
          peer_name: User.peer.peer_name,
          visa_peer_id: User.peer.visa_peer_id,
        });
      }).catch(() => {
        this.batchDownloadLoading = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.on-job-list-page{
  padding: 20px 0;
  min-height: calc(~"100vh - 395px");
  .page-body{
    width: 1120px;
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
    border-radius: 2px;
    .tab-box{
      width: 100%;
      height: 60px;
      border-bottom: 1px solid #F0F0F0;
      display: flex;
      padding: 0 32px;
      .tab-item{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333;
        font-size: 16px;
        position: relative;
        &.active{
          color: #599FFF;
          &::after{
            content: "";
            width: 30px;
            height: 4px;
            background: #599FFF;
            border-radius: 1px;
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
          }
        }
      }
    }
    .list-box{
      padding: 24px;
      .list-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .search-box{
          position: relative;
          width: 340px;
        }
      }
      .list-body{
        margin: 24px 0;
        .passport-img-box{
          font-size: 0;
          .passport-img{
            width: 70px;
            cursor: pointer;
          }
        }
        .customer-name{
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .list-footer{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .handler-box{
          display: flex;
          align-items: center;
          .s-btn+.s-btn{
            margin-left: 20px;
          }
        }
      }
      .search-nodata{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 0;
        .nodata-img{
          width: 200px;
          height: 120px;
        }
        .nodata-text{
          color: #91999F;
          font-size: 16px;
          line-height: 24px;
          margin-top: 4px;
        }
      }
    }
    .nodata-box{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 60px 0;
      .nodata-img{
        width: 200px;
        height: 120px;
      }
      .nodata-text{
        color: #91999F;
        font-size: 16px;
        line-height: 24px;
        margin-top: 6px;
        text-align: center;
      }
      .add-btn{
        margin-top: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/on-job/OnJobList.vue